/**
 * Servizio minimale per gestire l'email dell'utente in localStorage.
 *
 * L'email funge da "gate" per accedere alla pagina Impostazioni e ai
 * pulsanti di export CSV/Excel: finché non è presente un'email valida,
 * l'accesso è bloccato da una modale di acquisizione.
 *
 * Nessun invio a server: i dati restano sul dispositivo.
 */
const EMAIL_KEY = 'hotel-roi:email:v1';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export class EmailService {
  static get(): string | null {
    if (typeof localStorage === 'undefined') return null;
    try {
      return localStorage.getItem(EMAIL_KEY);
    } catch {
      return null;
    }
  }

  static set(email: string): boolean {
    if (!this.isValid(email)) return false;
    try {
      localStorage.setItem(EMAIL_KEY, email.trim().toLowerCase());
      return true;
    } catch {
      return false;
    }
  }

  static clear(): void {
    try {
      localStorage.removeItem(EMAIL_KEY);
    } catch {
      /* noop */
    }
  }

  static isValid(email: string): boolean {
    return EMAIL_RE.test(email.trim());
  }
}
